import type {ReactElement} from 'react';
import React, {useEffect, useState} from 'react';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {Modal} from '@Components/modal';
import type {MediaTypePanelProps} from '@Panels/media-type-panel/media-type-panel';
import {useAppSelector} from '@/hooks';

export type MediaTypeModalProps = MediaTypePanelProps;

const PANEL_ID = 'media-type-panel';
export default function MediaTypeModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.MEDIA_TYPE_MODAL];
  });

  const sizeData = useAppSelector((state) => {
    return state.panels.sizeDataHashmap[PANEL_ID];
  });

  const [width, setWidth] = useState('612px');
  const [height, setHeight] = useState('280px');

  useEffect((): void => {
    if (sizeData?.width) {
      setWidth(sizeData.width);
    }
    if (sizeData?.height) {
      setHeight(sizeData.height);
    }
  }, [sizeData]);

  return (
    <Modal modalId={MODALS_IDS.MEDIA_TYPE_MODAL} panelId={PANEL_ID} modalWidth={width} modalHeight={height} isBottomSheetOnMobile>
      <LazyPanel
        panelDirectoryName={PANEL_ID}
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openMediaTypeModal = (props: MediaTypeModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.MEDIA_TYPE_MODAL,
      panelProps: props,
    })
  );
};
